import { dao } from '@platform/dao';
import type { IInvitationList, IInvitationWrite, IWorkspaceInvitation } from '@platform/dao';
import { baseApi, run } from './baseApi';

/**
 * Запрошення робочого простору (Головна › Учасники › Запрошення): перелік (сервер без цього API — { available: false } і порожньо),
 * надсилання, повторне надсилання й відкликання; зміни оновлюють перелік і лічильник лівого меню.
 */
export const invitationsApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    invitations: b.query<IInvitationList, string>({
      queryFn: (ws) => run(() => dao.workspaces.invitations(ws)),
      providesTags: (_r, _e, ws) => [{ type: 'Workspaces', id: `inv:${ws}` }],
    }),
    invite: b.mutation<IWorkspaceInvitation, { ws: string; body: IInvitationWrite }>({
      queryFn: ({ ws, body }) => run(() => dao.workspaces.invite(ws, body)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Workspaces', id: `inv:${ws}` }],
    }),
    revokeInvitation: b.mutation<void, { ws: string; id: string }>({
      queryFn: ({ ws, id }) => run(() => dao.workspaces.revokeInvitation(ws, id)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Workspaces', id: `inv:${ws}` }],
    }),
    resendInvitation: b.mutation<IWorkspaceInvitation, { ws: string; id: string }>({
      queryFn: ({ ws, id }) => run(() => dao.workspaces.resendInvitation(ws, id)),
      invalidatesTags: (_r, _e, { ws }) => [{ type: 'Workspaces', id: `inv:${ws}` }],
    }),
  }),
});

export const { useInvitationsQuery, useInviteMutation, useRevokeInvitationMutation, useResendInvitationMutation } = invitationsApi;
